import React from 'react';
import { IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonBadge } from '@ionic/react';

import './Card.css'

interface CardProps {
  route?: string,
  meal: {
    id: string,
    name: string,
    createdAt: Date,
    avgRating: number,
    photoURL: string,
    type: string,
  }
}

const Card: React.FC<CardProps> = ({ route, meal : { id, name, avgRating, createdAt, photoURL, type }}) => {
  let wType;
  switch (type) {
    case 'breakfast':
      wType = 'Petit Déjeuner'
      break;
    case 'lunch':
      wType = 'Déjeuner'
      break;
    case 'snack':
      wType = 'Collation'
      break;
    default:
      wType = 'Diner'
      break;
  }
  return (
    <IonCard routerLink={route ? `/home/flow/${id}?name=${name}` : `/home/meals/${id}?name=${name}`} className='mealCard'>
      <div style={{position:'relative'}}>
        <img src={photoURL} alt={name} />
        { avgRating && <IonBadge color="tertiary" className="note" >Note : {avgRating}/20</IonBadge> }
        { wType && <IonBadge color="light" className="type" >{wType}</IonBadge> }
      </div>

      <IonCardHeader>
        <IonCardSubtitle color='success'>{createdAt.toLocaleString()}</IonCardSubtitle>
        <IonCardTitle>{name}</IonCardTitle>
      </IonCardHeader>
    </IonCard>
  );
};

export default Card;
